import { render, staticRenderFns } from "./owner-sold-products.vue?vue&type=template&id=66349526&scoped=true"
import script from "./owner-sold-products.vue?vue&type=script&lang=js"
export * from "./owner-sold-products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66349526",
  null
  
)

export default component.exports